<div class="booking-action-container">
  <app-toast *ngIf="showUpdateInvoiceStatusSuccess" [message]="updateMessage" (dismissCallback)="toggleSuccessToast()">
  </app-toast>
  <!-- <app-button title="Cancel Booking" *ngIf="bookingActionBtnConfigObj['Cancel'].visibility.visible"
    (clickCallback)="toggleCancelConfirmDialog({booking: booking})" class="mr-5" type="icon"
    prefixIconSrc="assets/cancel.svg" [disabled]="booking.isCancelDisabled"></app-button> -->
  <div class="status-container" [ngClass]="{'disabled': booking.bookingStatus === 'CANCELLED'}">
    <app-status-cards [booking]="booking"></app-status-cards>
  </div>

  <div *ngIf="bookingActionConfig.config.visibility.visible">
    <div class="trigger" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <app-button type="icon" prefixIconSrc="assets/actions-dropdown.svg" (click)="isOpen=true"></app-button>
    </div>
    <ng-template 
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="isOpen=false"
    >
      <div class="booking-item-menu" (click)="isOpen=false;">

        <!-- <div class="garage-wrapper menu-item" (click)="toggleGarageMapping()"> -->
        <!-- <div class="garage-wrapper menu-item" (click)="isAssignCab =!isAssignCab; assign()">
          <img src="assets/images/assign-add.svg" />
          <label>Assign</label>
        </div> -->

        <div class="invoice-wrapper menu-item" (click)="handleEditBooking({booking: booking})"
          *ngIf="bookingActionBtnConfigObj['Edit'].visibility.visible" [ngClass]="{'disabled': booking.isEditDisabled}">
          <img src="assets/edit_black.svg" alt="edit-button">
          <label for="">Edit</label>
        </div>
        <div class="garage-wrapper menu-item" (click)="showRemoveCabModal=true" [ngClass]="{'disabled': !this.booking.cab}">
          <img src="assets/remove_cab.svg" />
          <label>Remove Cab</label>
        </div>
        <ng-container  *ngIf="bookingActionBtnConfigObj['Assign']; else AssignBtn ">
        <div class="invoice-wrapper menu-item" *ngIf="bookingActionBtnConfigObj['Assign']?.visibility?.visible"
            (click)="isAssignCab =!isAssignCab; assign()" [ngClass]="{'disabled':(booking.tripStatus=='TRIP_EXPIRED' || booking.bookingStatus=='CANCELLED') || (this.authService.user.role?.toLowerCase()=='vendor_manager' && booking.vendorStatus!=='ACCEPTED')}">
              <img src="assets/images/assign-add.svg" />
              <label> Assign</label>
            </div>
          </ng-container>
          <ng-template #AssignBtn>
            <div class="invoice-wrapper menu-item" 
            (click)="isAssignCab =!isAssignCab; assign()" [ngClass]="{'disabled':booking.tripStatus=='TRIP_EXPIRED' || booking.bookingStatus=='CANCELLED'}">
              <img src="assets/images/assign-add.svg" />
              <label> Assign</label>
            </div>
          </ng-template>
        <ng-container *ngFor="let item of bookingActionConfig?.elementConfigList">
          <div class="invoice-wrapper menu-item" [ngClass]="{'disabled': booking['Approve-disable'] === true}"
          (click)="handleStatusUpdate({action: 'manager_status_update', status: 'APPROVED', bookingId: booking.bookingId})"
          *ngIf="item.elementKey ==='Approve' && item.config.visibility.visible">
          <img src="assets/assign_approve.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>
        <div class="invoice-wrapper menu-item" [ngClass]="{'disabled': booking['Reject-disable'] === true}"
          (click)="handleStatusUpdate({action: 'manager_status_update', status: 'REJECTED', bookingId: booking.bookingId})"
          *ngIf="item.elementKey === 'Reject' && item.config.visibility.visible">
          <img src="assets/assign_cancelled.svg" />
          <label>{{ item.config.displayName }}</label>

        </div>
        <div class="invoice-wrapper menu-item" [ngClass]="{'disabled': booking.guardReq=== false}"
          (click)="showAssignMarshallPopupFn(booking); getMarshallOffice(booking.bookingId)"
          *ngIf="item.elementKey === 'AssignMarshall' && item.config.visibility.visible">
          <img src="assets/assignMarshall.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>

        <div class="invoice-wrapper menu-item" [ngClass]="{'disabled': booking['Accept-disable'] === true}"
          (click)="handleStatusUpdate({action: 'vendor_status_update', status: 'ACCEPTED', bookingId: booking.bookingId})"
          *ngIf="item.elementKey === 'Accept' && item.config.visibility.visible">
          <img src="assets/images/assign_approve.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>
        <div class="invoice-wrapper menu-item" [ngClass]="{'disabled': booking['Deny-disable'] === true}"
          (click)="handleStatusUpdate({action: 'vendor_status_update', status: 'DENIED', bookingId: booking.bookingId})"
          *ngIf="item.elementKey === 'Deny' && item.config.visibility.visible">
          <img src="assets/assign_cancelled.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>

        <div class="invoice-wrapper menu-item" (click)="handleEditBooking({booking: booking})"
          *ngIf="item.elementKey === 'Edit' && item.config.visibility.visible" [ngClass]="{'disabled': booking.isEditDisabled}">
          <img src="assets/edit_black.svg" alt="edit-button">
          <label for="">Edit</label>
        </div>

        <div class="duplicate-booking-wrapper menu-item" (click)="handleDuplicateBooking()"
          *ngIf="item.elementKey === 'Duplicate' && item.config.visibility.visible">
          <img src="assets/assign_duplicate.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>

        <div class="invoice-wrapper menu-item"
        (click)="toggleCancelConfirmDialog({booking: booking})"  [ngClass]="{'disabled': booking.isCancelDisabled}"
        *ngIf="item.elementKey === 'Cancel' && item.config.visibility.visible">
        <img src="assets/assign_cancelled.svg" />
        <label>{{ item.config.displayName }}</label>
      </div>

        <div class="duplicate-booking-wrapper menu-item" (click)="viewDocuments()"
        *ngIf="item.elementKey === 'View Document' && item.config.visibility.visible">
        <img src="assets/documentIcon.svg" />
        <label>{{ item.config.displayName }}</label>
      </div>

        <div class="email-wrapper menu-item" (click)="toggleSendComm()"
          *ngIf="item.elementKey === 'Send SMS/Email' && item.config.visibility.visible"
          [ngClass]="{'disabled': booking['Send SMS/Email-disable'] === true}">
          <img src="assets/assign-email.svg" />
          <label>{{ item.config.displayName }}</label>
        </div>

        <div class="track-wrapper menu-item" [ngClass]="{'disabled': booking['Track-disable'] === true}"
          *ngIf="item.elementKey === 'Track' && item.config.visibility.visible" (click)="toggleTracking()">
          <img src="assets/assign-location.svg" />
          <label>{{item.config.displayName}}</label>
        </div>

        <div class="geo-code-wrapper menu-item" [ngClass]="{'disabled': booking['Fix Geo-code-disable'] === true}"
          *ngIf="item.elementKey === 'Fix Geo-code' && item.config.visibility.visible" (click)="toggleGeoCode()">
          <img src="assets/assign_fix-geo.svg" />
          <label>{{item.config.displayName}}</label>
        </div>

        <div class="history-wrapper menu-item" (click)="showBookingHistory()"
          *ngIf="item.elementKey === 'Audit History' && item.config.visibility.visible">
          <img src="assets/assign_history.svg" />
          <label>{{item.config.displayName}}</label>
        </div>
        <div class="garage-wrapper menu-item" (click)="showRemoveCabModal=true" *ngIf="item.elementKey === 'Remove Cab' && item.config.visibility.visible">
          <img src="assets/remove_cab.svg" />
          <label>Remove Cab</label>
        </div>
        </ng-container>
      </div>
    </ng-template>
  </div>

  <!-- -----------marshall assign popover  -->
  <app-popover *ngIf="showAssignMarshallPopup" size="small" titleText="Assign Marshall"
    (closeCallback)="showAssignMarshallPopup=false" [sendHeader]="true"
    [subheaderText]="'Booking ID: '+ booking.bookingId">
    <div popover-content class="assign-marshall">
      <div class="marshall-dropdown mb-24">
        <div class="geoaraea-label mb-8">Marshall</div>
        <mis-dropdown [data]="marshallData" height="38px" label="Select" dropdownListHeight="200px"
          (onChange)="getMarshall($event)" dropdownListPosition="Left" [searchEnabled]="true"
          [selectedItem]="selectedMarshall" noDataMessage="No Data"></mis-dropdown>
      </div>

      <div class="office-dropdown">
        <div class="geoaraea-label mb-8">Office</div>
        <mis-dropdown [data]="officeData" height="38px" label="Select" dropdownListHeight="200px"
          (onChange)="getOffice($event)" dropdownListPosition="Left" [searchEnabled]="true"
          [selectedItem]="selectedOffice" noDataMessage="assignMarshallNo Data"></mis-dropdown>
      </div>
    </div>
    <div popover-actions class=" flex flex-end">
    <app-button class="mr-10" type="plainText" text="Unassign Marshall" (click)="deleteMarshallModal=true;showAssignMarshallPopup=false" [ngClass]="{'disabled': !selectedMarshall.label }"></app-button>
      <app-button type="primaryFilled" text="Apply" (clickCallback)="applyMarshall()"></app-button>
    </div>
  </app-popover>

  <app-dialog *ngIf="showMarshallWarningPopup" titleText="Warning" type="confirm" [buttonText]="['Assign', 'Cancel']"
    (approveCallback)="assignMarshall(booking.bookingId)" (dismissCallback)="showMarshallWarningPopup=false"
    (closeCallback)="showMarshallWarningPopup=false" icon="true" src="assets/ic-ui-warning-24.svg">
    As per your company policy, by assigning a marshall to this booking, the current pickup time of
    <span class="font-weight-700">{{ myBookingService.getDatePart(booking.startTime,'time') }}</span>
    will be changed to <span class="font-weight-700">{{ myBookingService.getDatePart(booking.startTime,'time') |
      timePrepone:preponeTripSheetInHours}}</span>.
  </app-dialog>

  <app-dialog *ngIf="reAssignPopup" titleText="Warning" type="confirm" [buttonText]="['Assign', 'Cancel']"
    (approveCallback)="assignMarshall(booking.bookingId)" (dismissCallback)="reAssignPopup=false"
    (closeCallback)="reAssignPopup=false" icon="true" src="assets/ic-ui-warning-24.svg">
    Are you sure you want to re-assign the marshall ?
  </app-dialog>

  <!-- <app-dialog *ngIf="cancelDialog" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
    (approveCallback)="cancelBooking(booking.bookingId,'')" (dismissCallback)="cancelDialog=false"
    (closeCallback)="cancelDialog=false" icon="true" src="assets/ic-ui-warning-24.svg">
    Are you sure you want to cancel the booking - {{booking.bookingId}} ?
  </app-dialog> -->

  <app-popover *ngIf="cancelDialog" size="Approver-model" (closeCallback)="cancelDialog=false">
    <div popover-header class="popover-header">Cancel Booking</div>

    <div popover-content class="reject-booking-section">
      <div class="mb-10 reason-container ">Please provide the reason </div>
      <textarea class="reject-text-area" name="reason" [(ngModel)]="reasonText" [maxlength]="maxLimit" #reasonControl="ngModel" rows="3">
    </textarea>
      <div *ngIf="reasonControl.invalid">
        <div class="error-msg" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field is mandatory</div>
        <div class="error-msg" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200characters)</div>
      </div>
    </div>

    <div popover-actions class="submit-button">
        <app-button type="plainText" text="Cancel" class="mr-20" (clickCallback)="cancelDialog=false"></app-button>
        <app-button type="primaryFilled" text="Submit" (clickCallback)="cancelBooking(booking.bookingId,'')"></app-button>
    </div>

</app-popover>

  <app-dialog *ngIf="showUnavailableWarning" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
    (approveCallback)="showUnavailableWarning=false;showMarshallWarningPopup=true" (dismissCallback)="showUnavailableWarning=false;showAssignMarshallPopup=true"
    (closeCallback)="showUnavailableWarning=false" icon="true" src="assets/ic-ui-warning-24.svg">
    Marshall <span class="font-weight-700">{{ selectedMarshall.label }}</span>
    is already assigned to a booking. Do you still want to proceed with this assignment?
  </app-dialog>

  <app-dialog *ngIf="deleteMarshallModal" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
    (approveCallback)="removeMarshall(booking.bookingId)" (dismissCallback)="deleteMarshallModal=false"
    (closeCallback)="deleteMarshallModal=false" icon="true" src="assets/ic-ui-warning-24.svg">
    Are you sure you want to unassign marshall: <span class="font-weight-700">{{ selectedMarshall.label }}</span>
    from booking: <span class="font-weight-700 fs-14"> {{booking.bookingId}}</span>
  </app-dialog>

  <app-dialog *ngIf="showRemoveCabModal" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
    (approveCallback)="removeCab()" (dismissCallback)="showRemoveCabModal=false"
    (closeCallback)="showRemoveCabModal=false" icon="true" src="assets/ic-ui-warning-24.svg">
    Are you sure you want to remove cab assigned for {{booking.bookingId}}.
  </app-dialog>

  <app-popover *ngIf="isAssignCab" size="Assign-cab-model" (closeCallback)="AssignCabModel(booking);">
    <div popover-header class="cab-assign-header">Assign</div>

    <!-- <div popover-content class="vendor-submit-wrapper"> -->
    <div popover-content class="cab-dropdown-container">
      <div class="vendor-select-wrapper mb-16">
        <!-- <mis-dropdown class="select-assign" [label]="'Select Vendor'" [data]="dropdownData" (onChange)="logSelect($event)" [selectedItem]="selectedItem"></mis-dropdown> -->
        <div class="assign-label fs-12">Vendor</div>
        <app-vendor-select
        [vendors]="vendors"
        [elementType]="vendorSelectConfigObj['VendorAssignment'].elementType"
        [selectedBookings]="selectedBookings"
        [vendorFormControl]="vendorFormControl"
        [vendorSelectConfigObj]="vendorSelectConfigObj"
        class="vendor-select"
        (globalVendorSelectedCallback)="onVendorValueSelected($event)"
        isGlobal=true
        [label]="booking?.cab?.vendor?.vendorName ? booking.cab.vendor.vendorName : booking?.vendor ? booking?.vendor?.vendorName : 'Select'"
        [ngClass]="{'disableDropdown':disableVendorDropdown ||  authService.user.role.toLowerCase()=='vendor_manager' }"
       >
      </app-vendor-select>
      </div>
      <div class="select-wrapper">
        <div class="displayFlex displayFlexRow displayFlexSpaceBetween">
          <span class="assign-label fs-12">Cab</span>
          <span class="displayFlex">
            <mis-checkbox [name]="name" [type]="'Default'" [checked]="false"
              (valueChange)="onShowAllCabCheck($event)"></mis-checkbox>
            <span class="ml-4 fs-12">Show all cabs</span>
          </span>
        </div>
        <ng-container *ngIf="vendorCabSelectFormGroup?.get(booking.bookingId)?.get('cab')">
          <app-select [config]="cabConfig" [type]="'dropdownAndSearch'"
            [formControl]="vendorCabSelectFormGroup.get(booking.bookingId).get('cab')"
            [options]="showAllCabs? allCabs : cabs"
            [getCustomOptionValue]="cabOptionsFormControlValues || cabs ? getCabsValue : null"
            [getCustomOptionLabel]="cabOptionsFormControlValues || cabs ? getCabsLabel : null"
            [label]="booking?.cab?.registration?booking.cab.registration:'Select'" (changeCallback)="selectCab($event)"
            (assignDriverToVirtualCab)="assignDriverToVirtualCab($event)">
          </app-select>
      </ng-container>

        <ng-template [ngIf]="showMappedVirtualCab">
          <div class="displayFlex mt-16" (onclick)="showAddVirtualCabModal()">
            <span class="displayFlex"><img src="assets/ic-ui-seperator-16.svg" alt="cab number information"></span>
            <span class="fs-14 ml-4">Cab mapped <span
                class="font-weight-700">{{driverDetails.driverCabNum}}</span></span>
          </div>
        </ng-template>
        <!-- <mis-dropdown class="select-assign"  [label]="'Select Cab'"[data]="dropdownData" (onChange)="logSelect($event)" [selectedItem]="selectedItem"></mis-dropdown> -->
        <!-- *ngIf="cabAllocationConfigObj && vendorCabSelectFormGroup.get(booking.bookingId)" -->
        <!-- {{JSON.stringify(cabs)}} -->
        <!--    <app-cab-select
        [booking]="booking"
        [cabs]="cabs"
        [elementType]="tabularConfigObj['Cab'].elementType"
          [cabAllocationConfig]="cabAllocationConfig"
          [showAvailableCabsConfig]="commonService.workflowConfig['showAvailablecabs']"
          [cabAllocationConfigObj]="cabAllocationConfigObj"
          [isNonCompliantVisible]="commonService.workflowConfig['showNonCompliantCabs']"
          [isNonCompliantSelectable]="commonService.workflowConfig['allowNonCompltCabsAlloc']"
          (handleBookingsUpdateCallback)="handleBookingUpdate($event)"
          [cabFormControl]="vendorCabSelectFormGroup.get(booking.bookingId).get('cab')"
          [cabOptionsFormControlValues]="vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').value"
          (cabSelectValidationsCallback)="cabSelectValidations($event)"
          (toggleAddCabCallback)="toggleAddCab($event)"
          (isPopupOpen)="openVirtualCabPopUp(true, booking)">
        </app-cab-select> -->
      </div>
      <div class="select-wrapper">
        <!-- [type]="formConstants.getElementType(tabularConfigObj['Driver'].elementType)"" -->
        <div class="assign-label fs-12">Driver</div>
        <div class="virtualCabDriverName displayFlex" *ngIf="showVirtualCabDriverName;else driver">
          {{driverDetails.driverName}}
        </div>
        <ng-template #driver>
          <app-select [config]="driverConfig" [type]="'dropdownAndSearch'"
            [formControl]="driverForm[booking.bookingId].get('driver')"
            [options]="driverForm[booking.bookingId].get('driverOption').value || driverList"
            [getCustomOptionValue]="getDriverValue" [getCustomOptionLabel]="getDriverName"
            [label]="booking?.cab?.driver.name ? booking.cab.driver.name:'Select'"
            (changeCallback)="selectedDriver($event, booking)">
          </app-select>
        </ng-template>
        <!-- <mis-dropdown class="select-assign" [label]="'Select Driver'" [data]="dropdownData" (onChange)="logSelect($event)" [selectedItem]="selectedItem"></mis-dropdown> -->
      </div>

    </div>
    <!-- </div> -->
    <!-- (click)="cancelVendorCabUpdate(booking)"  -->
    <div popover-actions class="submit-button">
      <button mis-button type="none" size="md" (click)="clearAssignModalUpdate(booking)" class="ml-16">
        Clear
      </button>
      <button mis-button type="primary" size="md" (click)="handleSubmitVendorUpdate()" class="apply-button ml-16">
        Apply
      </button>
    </div>
  </app-popover>

  <app-dialog *ngIf="showVendorChangeDialog" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
    (approveCallback)="approveVendorChange()" (dismissCallback)="rejectVendorChange()"
    (closeCallback)="showVendorChangeDialog=false"icon="true" src="assets/ic-ui-warning-24.svg">
    Are you sure you want to proceed with the following changes?
  </app-dialog>

  <app-send-communication (showSuccessToastCallback)="handleSuccessToastToggle($event)" *ngIf="isSendCommVisible"
    (closeCallback)="toggleSendComm()" [bookings]="[booking]">
  </app-send-communication>

  <app-cab-track *ngIf="isTrackingVisible" (closeCallback)="toggleTracking()" [booking]="booking"></app-cab-track>

  <!-- <app-send-communication (showSuccessToastCallback)="handleSuccessToastToggle($event)" *ngIf="isSendCommVisible"
      (closeCallback)="toggleSendComm()" [bookings]="[booking]"></app-send-communication> -->

  <app-garage-mapping *ngIf="isGarageMappingVisible" (showSuccessToastCallback)="handleSuccessToastToggle($event)"
    (closeCallback)="toggleGarageMapping()" [booking]="booking"></app-garage-mapping>
  <app-geocode *ngIf="isGeoCodeVisible" (closeCallback)="toggleGeoCode()" [booking]="booking"
    [miscelleneousConfig]="miscelleneousConfig"></app-geocode>
  <app-cancel-booking-popover *ngIf="showCancelConfirmDialog" title="Cancel Booking"
    confirmationText="Are you sure you want to cancel this booking" [bookingOrRequestId]="cancelBookingInfo.bookingId"
    [cancelPopupConfig]="cancelPopupConfig" (approveCallback)="handleCancelBooking($event)"
    (dismissCallback)="dismissCancelBookingDialog()"></app-cancel-booking-popover>
  <app-dialog *ngIf="showEditBookingError" (approveCallback)="hideEditBookingError()" type="alert"
    [buttonText]="['Okay']">
    {{editCutOffDetails.errorMessage}}
  </app-dialog>
  <app-view-invoice *ngIf="isViewInvoiceVisible" (toggleLoadingOnViewInvoice)="handleToggleLoadingOnViewInvoice($event)"
    (showSuccessErrorAction)="showSuccessErrorAction($event)" [booking]="booking" (closeCallback)="toggleViewInvoice()">
  </app-view-invoice>
  <app-dialog *ngIf="showUpdateInvoiceStatusError" (approveCallback)="hideStatusError()" type="alert"
    [buttonText]="['Okay']">
    {{updateMessage}}
  </app-dialog>

  <app-dialog *ngIf="showWarning" titleText="Error" (approveCallback)="hideStatusError()" type="error"
    [buttonText]="['Okay']">
    Please assign the Vendor first
  </app-dialog>


  <!-- --------------add driver to existing Virtual cab -->
  <app-popover *ngIf="assignDriverToVirtualCabPopup" size="VirtualCab-model"
    (closeCallback)="assignDriverToVirtualCabPopup=false">
    <div popover-header class="popover-header font-weight-700">Assign Driver to Virtual Cab</div>

    <div popover-content class="add-driver-container">
      <div class="driverName mb-16 displayFlex">
        <span class="assignDriverLabel mr-12">Driver Name</span>
        <span><input type="text" class='inputField' placeholder="Type Name" [(ngModel)]="driverDetails.driverName"
            (keypress)="checkInput()"></span>
      </div>

        <div class="mobileNum mb-16 displayFlex">
          <span class="assignDriverLabel mr-12">Mobile</span>
          <span class="assignDriverPhone">
            <mis-phone-input 
            [dropdownSelectedItem]="selectedCountryCode"
            [dropdownWidth]="'12vw'" 
            [inputHeight]="'32px'" 
            [dropdownHeight]="'32px'" 
            [dropdownData]="dropdownData"
            (onDropdownSelection)="countryCodeSelection($event)"
            (change)="getDriverPhone($event)"
            [inputFormControl] = "phonenumber"
            [searchEnabled]="true"
            [searchLabel]="'Search'"
            (keypress)="checkInput()"
            ></mis-phone-input>
          </span>
        </div>

      <div class="registrationNum displayFlex">
        <span class="assignDriverLabel mr-12">Registration Number</span>
        <span><input type="text" class='inputField' placeholder="Type here" [(ngModel)]="driverDetails.driverCabNum"
            (keypress)="checkInput()"></span>
      </div>
    </div>


    <div popover-actions class="submit-button">
      <app-button type="plainText" text="Clear" class="mr-20" (clickCallback)="clearUpdate()"
        [disabled]="!enableBtn"></app-button>
      <app-button type="primaryFilled" text="Submit" (clickCallback)="submitVirtualCabDriver()" [disabled]="!enableBtn"
        [btnType]="successBtn"></app-button>
    </div>

  </app-popover>

  <!-- -----view document modal  -->
  <app-popover *ngIf="showDocumentModal" size="view-document-modal" titleText="View Document"
    (closeCallback)="showDocumentModal=false">

    <div popover-content>
    <!-- -----------docs uploaded -->
    <div *ngIf="documentList.length>0;else noDoc" class=" viewDocuments" >
     <div class="displayFlexColumn mb-16">
          <div class="mb-16" *ngFor="let image of documentList; let i = index">
              <div class="doc-items displayFlex">
                  <div class="displayContents">
                      <div class=" displayContents">
                          <img src="assets/documentIcon.svg" alt="">
                      </div>
                      <div class="ml-8 displayFlexColumn" style="width: 80%;">
                          <span>{{image.filename}}</span>
                          <span>{{myBookingService.convertToMB(image.filesize)}} MB</span>
                      </div>
                      <div class="viewDoc">
                        <button (click)="myBookingService.downloadDocument(image.filename,booking.bookingId)">View</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <ng-template #noDoc>
    No Document Uploaded
  </ng-template>
  <!-- -----------docs -->
    </div>
</app-popover>
</div>